import { createSlice } from "@reduxjs/toolkit";

export const areaSelectedSlice = createSlice({
    name: 'areaselected',
    initialState: {
        level: 1,
        value: "thailand",
        bbox: []
    },
    reducers: {
        // setAreaSelectedLevel: (state, action) => {
        //     state.level = action.payload;
        // },
        // setAreaSelectedValue: (state, action) => {
        //     state.value = action.payload;
        // },
        // setAreaSelectedBBox: (state, action) => {
        //     state.bbox = action.payload;
        // },
        setAreaSelected: (state, action) => {
            state.level = action.payload.level;
            state.value = action.payload.value;
            state.bbox = action.payload.bbox;
        }
    }
})

// export const { setAreaSelectedLevel, setAreaSelectedValue, setAreaSelectedBBox, setAreaSelected } = areaSelectedSlice.actions;
export const { setAreaSelected } = areaSelectedSlice.actions;

export const getAreaSelected = (state) => state.areaselected;

export default areaSelectedSlice.reducer;